import { readContracts, readContract } from 'wagmi/actions';
import { config } from '../../wagmi';
export const multiReadContract = async (contracts: any[]) => {
  const result = await readContracts(config, {
    contracts: contracts,
  });
  return result;
}

export const readContractOnce = async (contract: any) => {
  const result = await readContract(config, contract);
  return result;
}
